<div class="modal-dialog">
    <div class="modal-content" style="overflow: hidden;"><div class="modal-header">
<table width="100%" border="0">
<tbody><tr><td align="left" valign="top">
<a href="JavaScript:btImprimirTicket('R202102240136371002')"><img class="icon" src="../../../assets/icons/print.png"  onclick="window.print();" target="" id="btimprimir"></a>
</td>
<td align="left" valign="top">
<h2 class="modal-title">&nbsp;&nbsp;<b><small>{{'customerService.requestDetails'|cxTranslate}} - {{ticketDetails?.id}}</small></b></h2>
</td>
<td align="left" valign="top">
<img title="Sanofi" alt="Sanofi" src="https://api.czz3177o4e-sanofiave3-d4-public.model-t.cc.commerce.ondemand.com/medias/webbLogo.png?context=bWFzdGVyfGltYWdlc3wzNDA2fGltYWdlL3BuZ3xoNDEvaDc4Lzg3OTkwODMwMzY3MDIvd2ViYkxvZ28ucG5nfDJkNTIxYmY5YmU0MDY2MjVjOTA4MTcwNDk1ZTQyMTYwMmI3YmVlYWUxNjNmMzE0Y2Q2ODQxNGE4NTc3YTQwN2Y">
</td>
<td align="left" valign="top">
    <div class="cls-btn">
        <img src="../../assets/icons/close.png" (click)="close()" alt="" />
      </div>
</td>
</tr></tbody></table>
</div>


<!--<div class="modal-body" >-->

<!-- <div class="alert feedback-negative hide-content">
    <ul>
        <li class="icon"><img src="/sanofistorefront/_ui/responsive/common/images/iconsfeedbackserror.png"></li>
        <li class="messages">
            <p>
            Insira uma mensagem válida.</p>
        </li>
    </ul>
</div> -->
<div class="modal-body">
<div class="container-fluid custom-media-col">
<div class="body-content">
    <div class="ticket-details-content">
        <div id="div_identificacao" class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <p class="header-text hidden-xs">{{'customerService.createdBy'|cxTranslate}}:</p>
                <p class="desc-text hidden-xs">{{createdBy}}</p>
                
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <p class="header-text hidden-xs">{{'customerService.creationDate'|cxTranslate}}:</p>
                <p class="desc-text hidden-xs">{{ticketDetails?.createdAt | slice:0:10 | date:'dd/MM/yyyy'}}</p>
                
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <p class="header-text hidden-xs">{{'customerService.businessUnit'|cxTranslate}}:</p>
                <p class="desc-text hidden-xs">{{ticketDetails?.b2bUnitId}} {{ticketDetails?.b2bUnitName}}</p>
                
            </div>
            </div>
    </div>
        <div id="div_tipodeticket" class="ticket-type-content padding-lr-none">
        <div class="ticket-details padding-lr-32">
            <div class="inner-content">
            <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 ticket-column">
                    <p class="header-text hidden-xs">{{'customerService.requestType'|cxTranslate}}:</p>
                    <p class="desc-text hidden-xs">{{ticketDetails?.ticketCategory?.name}}</p>
                    
                    </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 theme-col ticket-column">
                        <p class="header-text hidden-xs">{{'customerService.theme'|cxTranslate}}:</p>
                    <p class="desc-text hidden-xs">{{ticketDetails?.ticketSubType}}</p>
                    
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 status-col ticket-column">
                        <p class="header-text hidden-xs">{{'customerService.status'|cxTranslate}}:</p>
                        <input type="hidden" id="ticketstatus" value="InAnalysis">
                        <p class="desc-text hidden-xs">{{ticketDetails?.status?.name}}<p>
                       
                        </div> 
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-lr-48">
                    <p class="header-text description-header">{{'customerService.descriptionlc'|cxTranslate}}:</p>
                <p class="desc-text">{{ticketDetails?.description}}</p>
            </div>
        </div>
        </div> 
<form id="supportTicketForm" action="/sanofistorefront/sanofiBR/pt/BRL/my-account/support-ticket/R202102240136371002?offset=-330&amp;_=1652877348311" method="post"><div class="files-list-content">
    <h3 class="h3-typo">{{'customerService.archieve'|cxTranslate}}</h3>
        <div class="header-row hidden-xs">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <h5 class="h5-typo first-col">{{'customerService.filename'|cxTranslate}}</h5>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <h5 class="h5-typo">{{'customerService.size'|cxTranslate}}</h5>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <h5 class="h5-typo">{{'customerService.uploadDate'|cxTranslate}}</h5>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2">											
                </div>
            </div>	
        </div>
        
        <div class="body-row hidden-xs">
            <div class="inner-row" *ngFor="let item of ticketAttachments">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                        <div class="ellipsis-col first-col"><div class="ellipsis-dom" title="{{item?.filename}}">{{item?.filename}}</div></div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <div>{{item?.filesize * 0.000001 | number}}<span> mb</span></div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <div>{{item?.uploadDate | slice:0:10 | date:'dd/MM/yyyy'}} </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div class="action-icon">
                        <div class="xp-button open-url">
                         <a href="{{baseUrl+item?.URL}}" download="{{item?.filename}}" target="_blank"> 
                          <img class="icon" src="../../../assets/icons/pdf.png"> 
                           </a>
                          </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="div_arquivos" style="display:none">
                <h3 class="h3-typo">Arquivo</h3>
                <table width="100%" style="border: 1px solid #ddd;">
                    <tbody><tr>
                    <td style="border: 1px solid #ddd;">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <h5 class="h5-typo first-col">Nome do arquivo</h5>
        </div>
                    </td>
                    <td style="border: 1px solid #ddd;">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <h5 class="h5-typo">Tamanho</h5>
                    </div>
                    </td>
                    <td style="border: 1px solid #ddd;">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <h5 class="h5-typo">Data de upload</h5>
                    </div>
                    </td>
                    </tr>
                    </tbody></table>
            </div>	
        </div>
        <div class="body-row-mobile hidden-lg hidden-md hidden-sm">
        </div>

        <div class="row create-ticket-upload-section">
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 drag-drop-file-section-desktop file-upload-content"
                [ngClass]="{disableUpload:this.uploadedFilesData?.length===10}">
                    <!-- <input type="button" class="browse-ticket sanofi-sapphire-button-primary" value="UPLOAD"> -->
                    <img id="icon-upload"  src="../../../assets/icons/ico-upload.png">
                    <label for="img" class="text browse-ticket">{{'customerService.fileUpload'|cxTranslate}}</label>

                    <input type="file" name="uploadfile" (change)="uploadFile($event)" id="img" style="display:none;"/>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 uploaded-file-section">
                    <div class="file row" id="uploaded_file3" *ngFor="let item of uploadedFilesData">

                        <span class="icon-pdf-summary pull-left"></span>
    
                        <a class="uploaded_filename pull-left" target="_blank" download="{{item?.fileName}}" [href]="sanitizer.bypassSecurityTrustUrl(item?.selectedBlobUrl)">{{item?.fileName}}</a>
    
                        <span class="icon-x-blue icon-cancel hidden-lg hidden-md hidden-sm" (click)="removeUploadedFile(item)"></span>
    
                      </div>
                </div>						
        </div>
        <div class="permission-text">
        {{'customerService.permissionTxt'|cxTranslate}}</div>
    </div>
    

<div class="history-ticket-content">
<input type="hidden" value="58fb50ab-5117-4fb6-9357-a56eefa7691b" name="CSRFToken">
<div id="div_historicoticket">
<h3 class="h3-typo"></h3>
    <div class="body-row">
        <div class="inner-row" *ngFor="let item of ticketHistory">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <p class="header-text" *ngIf="item?.addedByAgent">{{'customerService.customer-Service'|cxTranslate}} - {{item?.createdAt | slice:0:19 | date:'dd/MM/yyyy hh:mm a'}} </p>
                             <p class="header-text" *ngIf="item?.author">{{item?.author}} - {{item?.createdAt | slice:0:19 | date:'dd/MM/yyyy hh:mm a'}}</p>
                             <p class="desc-text">{{item?.message}}</p>
                    </div>
                </div>
            </div>
        </div>
</div>	
    <div class="comment-content"> 
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    {{'customerService.comments'|cxTranslate}}<input id="id" name="id" value="R202102240136371002" type="hidden"><input type="hidden" value="" id="status" name="status">
                    <div class="row" [formGroup]="ticketUpdateForm">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <textarea id="description" name="description" [ngClass]="{
                                invalidClass:
                                !ticketUpdateForm.get('ticketDesc').value && updateTicketClicked
                              }" maxlength="4000" formControlName="ticketDesc"></textarea>
                              <span class="txt-error" *ngIf="
                              !ticketUpdateForm.get('ticketDesc').value && updateTicketClicked
                            ">{{ "addToCartItems.fieldReq" | cxTranslate }}</span>
                           
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                            <div class="hint-text">{{'customerService.max-characters'|cxTranslate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
<input type="hidden" name="CSRFToken" value="58fb50ab-5117-4fb6-9357-a56eefa7691b">
</div></form></div>
</div>
<div class="button-outer-content">
<div class="container-fluid custom-media-col">
    <div class="button-content">
                <input class="sanofi-sapphire-button-primary-hl" type="button" id="updateTicket" (click)="updateTicket()" value="SALVAR">
                </div>
        </div>
    </div>
<div>&nbsp;</div>
<div>&nbsp;</div>
</div>

<!--</div>-->	


</div>
</div>